export default "__VITE_ASSET__37a8d3a2__"